import { Grid, Typography } from '@mui/material'
import TableIcon from '@mui/icons-material/TableBar'

export const TopSection = ({
    orderName,
    tableName,
    customerName,
}: {
    orderName?: string
    tableName?: string
    customerName?: string
}) => {
    return (
        <>
            <Grid
                container
                spacing={2}
                alignItems={'flex-end'}
                direction={'row'}
            >
                <Grid item>
                    <Typography variant="h5" color={'primary'}>
                        {orderName! ? `#${orderName}` : 'New order'}
                    </Typography>
                </Grid>
                {customerName && (
                    <Grid item sx={{ marginLeft: 'auto' }}>
                        <Typography variant="h5" color={'primary'}>
                            {customerName}
                        </Typography>
                    </Grid>
                )}
            </Grid>
            {tableName && (
                <Grid item pt={1} container spacing={1} direction={'row'}>
                    <Grid item justifySelf={'center'}>
                        <TableIcon color="primary" />
                    </Grid>
                    <Grid item justifySelf={'center'}>
                        <Typography color={'primary'}>{tableName}</Typography>
                    </Grid>
                </Grid>
            )}
        </>
    )
}
